import { PharmaMedizinopferEntry } from '@/model/pharma-medizinopfer';

import { DataFetcher } from './fetcher/DataFetcher/index.ts';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface PharmaMedizinopferSearchParams extends AbstractSearchParams {
  symptom_disease?: string;
  country?: string;
  gender?: string;
  language?: string;
}

export class PharmaMedizinopferRepository extends RepositoryNocoDbBase<
  PharmaMedizinopferEntry,
  PharmaMedizinopferSearchParams
> {
  protected readonly TABLE_NAME = 'pharma_medizinopfer';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly DATE_FIELD = 'originally_published_at';

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS: (keyof PharmaMedizinopferEntry)[] = ['symptom_disease', 'country', 'gender'];

  protected readonly SEARCH_FIELDS: (keyof PharmaMedizinopferEntry)[] = [
    'remark',
    'symptom_disease',
    'symptom_addition',
    'firstname_damaged'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
